import { Route, Switch, useParams } from 'react-router-dom';

import { memberSocialPosts, memberSocialPostsLiked, memberSocialPostsSaved } from '@urls';
import { ProfilSocialPostsAsideContainer } from '@containers/profile/ProfilSocialPostsAside';
import { ProfileSocialPostsContainer } from '@containers/profile/ProfileSocialPosts';
import { ProfileSocialPostsSavedContainer } from '@containers/profile/ProfileSocialPostsSaved';
import { ProfileSocialPostsLikedContainer } from '@containers/profile/ProfileSocialPostsLiked';

import s from './ProfilePostsPage.sss';

type Params = {
  username?: string
};

export const ProfilePostsPage: React.FC = () => {
  const { username } = useParams<Params>();

  if (!username) {
    throw new Error('No username in params');
  }

  return (
    <div className={s.root}>
      <aside className={s.asideHolder}>
        <ProfilSocialPostsAsideContainer className={s.aside} />
      </aside>

      <main className={s.main}>
        <Switch>
          <Route
            path={memberSocialPosts}
            component={ProfileSocialPostsContainer}
            exact={true}
          />
          <Route
            path={memberSocialPostsSaved}
            component={ProfileSocialPostsSavedContainer}
            exact={true}
          />
          <Route
            path={memberSocialPostsLiked}
            component={ProfileSocialPostsLikedContainer}
            exact={true}
          />
        </Switch>
      </main>
    </div>
  );
};

export default ProfilePostsPage;
